export const lucide = 'shrink-0 !p-0 !text-current';

export const focusRing = 'outline-none focus-visible:ring-2 focus-visible:ring-brand-focus';

export const iconButton = `inline-flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-control border-0 bg-transparent p-0 text-ink-secondary hover:bg-surface-muted hover:text-ink disabled:cursor-default disabled:opacity-50 ${focusRing}`;

export const secondaryButton = `inline-flex h-8 shrink-0 cursor-pointer items-center gap-1.5 rounded-control border border-solid border-line bg-surface px-3 text-footnote font-semibold text-ink hover:bg-surface-muted disabled:cursor-default disabled:opacity-60 ${focusRing}`;

export const brandButton = `inline-flex h-9 shrink-0 cursor-pointer items-center gap-2 rounded-control border-0 bg-brand px-4 text-callout font-medium text-white hover:bg-brand-hover disabled:cursor-default disabled:bg-brand-disabled ${focusRing}`;

export const tintButton = `inline-flex h-8 shrink-0 cursor-pointer items-center gap-1.5 rounded-control border-0 bg-brand-tint px-3 text-footnote font-semibold text-brand-ink hover:bg-brand-tint-subtle disabled:cursor-default disabled:opacity-60 ${focusRing}`;

export const timeChip = `inline-flex h-6 cursor-pointer items-center gap-1 rounded-badge border-0 bg-surface-muted px-2 text-footnote font-medium tabular-nums text-ink-secondary hover:bg-brand-tint hover:text-brand-ink ${focusRing}`;

export const sectionTitleBase = 'm-0 text-caption uppercase tracking-[0.04em]';

export const sectionTitle = `${sectionTitleBase} text-ink-muted`;

export const readingMeasure = 'max-w-[34em]';

export const bodyText = `m-0 ${readingMeasure} text-callout font-normal leading-[1.55]`;

export const motionEase = 'ease-out-expo motion-reduce:transition-none';
